import { inputValidation, passwordChecker } from './inputsValidations.js';

/**
 * Add class for floating labels
 */
const floatingLabels = () => {
    const loginForm = document.querySelector( '.login-form' );

    if ( ! loginForm ) {
      return;
    }

    const fields = loginForm.querySelectorAll( 'input' );

    for ( const field of fields ) {
        const parentDiv = field.closest( '.field' );

        if ( ! parentDiv ) {
            continue;
        }

        const label = parentDiv.querySelector( 'label[for="' + field.id + '"]' );

        const valueChecker = () => {
            if ( field.value !== '' )   {
                label.classList.add( 'floating-label' );
            } else  {
                label.classList.remove( 'floating-label' );
            }
        };

        field.addEventListener( 'input', valueChecker );
        field.addEventListener( 'focus', valueChecker );
        field.addEventListener( 'focusout', valueChecker );
        field.addEventListener( 'blur', valueChecker );

        field.addEventListener( 'animationstart', ( event ) => {
            if ( event.animationName === 'onAutoFillStart' ) {
                label.classList.add( 'floating-label' );
            } else {
                label.classList.remove( 'floating-label' );
            }
        })

        valueChecker();
    }
}

/**
 * Don't focus input when clicking forgot password link
 */
function preventInputFocus() {
    const forgotPasswordLink = document.getElementById( 'forgot-password-link' );

    if ( forgotPasswordLink ) {
        forgotPasswordLink.addEventListener( 'mousedown', function( event ) {
            event.preventDefault();
        } );

        forgotPasswordLink.addEventListener( 'click', function( event ) {
            event.preventDefault();
            window.location.href = this.href;
        } );
    }
}

const formsValidation = () => {
	const forms = document.querySelectorAll( '.needs-validation' );

	Array.from( forms ).forEach( form => {
		const fields = form.querySelectorAll( '.field' );
		form.addEventListener( 'submit', event => {
			if ( ! form.checkValidity() ) {
				event.preventDefault();
				event.stopPropagation();
				inputValidation( 'input[name="email"]', '.invalid-email', 'email' );
			}
			fields.forEach( field => {
				if ( field.querySelector( 'input:invalid' ) ) {
					field.classList.add( 'is-invalid' );
				}
				field.addEventListener( 'keyup', () => {
					if ( field.querySelector( 'input:invalid' ) ) {
						field.classList.add( 'is-invalid' );
					} else {
						field.classList.remove( 'is-invalid' );
					}
				} );
			} );
			form.classList.add( 'was-validated' );
		}, false );
	} );
};

window.addEventListener( 'DOMContentLoaded', () => {
    floatingLabels();
    preventInputFocus();
	formsValidation();
    passwordChecker();
} );
